import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileName'
})
export class FileNamePipe implements PipeTransform {

  transform(value: string, args?: any): any {
    if (typeof value == 'string') {
      let parts = value.split('/');
      return parts[parts.length - 1].length > 20 ? parts[parts.length - 1].slice(0, 20) + '...' : parts[parts.length - 1];
    }
    else {
      return '';
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/onboarding/pipes/file-name.pipe.ts